@use "../../../globals/bcp";
@use "../../../globals/settings";

bcp-quantity-update {
  .quantity-selector {
    position: relative;
    width: 100%;
    display: flex;

    .quantity-input-field {
      box-sizing: border-box;
      border: 0;
      border-bottom: 1px solid #d0d0d0;
      padding: settings.$input-padding;
      font-size: bcp.size(14);
      line-height: 1.4;
      color: #555;
      background-color: transparent;
      width: 100%;
      min-width: 0;

      &:focus {
        border-color: settings.$color-black;
        outline: 0;
        box-shadow: none;
      }
    }

    .quantity-button-group {
      border-bottom: 1px solid #d0d0d0;
      flex: 0 0 auto;
      display: flex;

      .quantity-button {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        width: bcp.size(32);
        height: bcp.size(32);
        background-color: transparent;

        svg {
          fill: #005691;
        }

        &:disabled:hover,
        &[disabled]:hover {
          color: #fff;
          background-color: #ccc;
          border-color: #ccc;
          cursor: not-allowed;
        }
      }
    }

    .no-spinners {
      -moz-appearance: textfield;
      appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  .cart-quantity-warning {
    color: #fcaf17;
    font-weight: 600;
    font-size: bcp.size(12);
    margin-top: bcp.size(5);
    min-height: 1px;
  }
}
